package com.arena_web.ui.localization

object AppStringsPL : AppStrings {

    // language selector
    override val headerProfileLanguage = "Język"
    override val headerProfileLanguageRecommended = "Zalecane"

    // common
    override val commonSeeAll = "Zobacz wszystko"
    override val commonNo = "Nie"
    override val commonYes = "Tak"
    override val commonConfirm = "Potwierdź"
    override val commonSend = "Wyślij"
    override val commonError = "Błąd"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Wyłącz wyciszenie"
    override val chatMenuMute = "Wycisz"
    override val chatMenuInviteMembers = "Zaproś członków"
    override val chatMenuLeaveGroup = "Opuść grupę"
    override val chatMenuDeleteChat = "Usuń czat"
    override fun chatRemoveMemberTitle(name: String) = "Usunąć $name?"
    override fun chatRemoveMemberWarning(name: String) = "Usunąć $name z grupy? Tej operacji nie można cofnąć."
    override val chatRemoveMemberAction = "Usuń"
    override val chatDefaultName = "Czat"
    override fun chatTypingOne(name: String) = "$name pisze..."
    override fun chatTypingMany(count: Int) = "$count osób pisze..."
    override fun chatMembersCount(count: Int) = "$count członków"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count członków, $online online"
    override val chatOnline = "Online"
    override val chatOffline = "Offline"
    override val chatEditCommunityTitle = "Edytuj społeczność"
    override val chatCommunityNameLabel = "Nazwa społeczności"
    override val chatCommunityNamePlaceholder = "Wpisz nazwę społeczności..."
    override val chatSaving = "Zapisywanie..."
    override val chatMessageInputPlaceholder = "Napisz wiadomość..."
    override val chatInviteMembersTitle = "Zaproś członków"
    override val chatSearchFriendsPlaceholder = "Szukaj znajomych..."
    override val chatNoFriendsToInvite = "Brak znajomych do zaproszenia"
    override val chatNoResults = "Brak wyników"
    override val chatInviting = "Zapraszanie..."
    override val chatInvite = "Zaproś"
    override fun chatInviteCount(count: Int) = "Zaproś ($count)"
    override val chatPanelTitle = "Czat Arena"
    override val chatSearchPlaceholder = "Szukaj czatu"
    override val chatFilterAll = "Wszystkie"
    override val chatFilterDirect = "Prywatne"
    override val chatFilterCommunity = "Społeczności"
    override val chatNoChatsFound = "Nie znaleziono czatów"
    override val chatNoConversationsYet = "Na razie brak rozmów"
    override val chatNewChatTitle = "Nowy czat"
    override val chatTabDirectMessage = "Wiadomość prywatna"
    override val chatTabCommunity = "Społeczność"
    override val chatSearchPeoplePlaceholder = "Szukaj wśród osób, które obserwujesz..."
    override val chatNotFollowingAnyone = "Nie obserwujesz jeszcze nikogo"
    override val chatCreating = "Tworzenie..."
    override val chatCreateCommunity = "Utwórz społeczność"
    override val chatSelectConversation = "Wybierz rozmowę"
    override fun chatReplyTo(name: String) = "Odpowiedz $name"
    override val chatUnknownSender = "Nieznany"
    override val chatUploading = "Przesyłanie..."
    override val chatEditingMessage = "Edytowanie wiadomości"
    override val chatSearchInChatPlaceholder = "Szukaj w czacie..."
    override fun chatSearchResultsFound(count: Int) = "Znaleziono: $count"
    override val chatGroupInfoTitle = "Informacje o grupie"
    override val chatUserInfoTitle = "Informacje o użytkowniku"
    override val chatDeleteChatAction = "Usuń czat"
    override val chatDeleteGroupAction = "Usuń grupę"
    override val chatLeaveGroupAction = "Opuść grupę"
    override val chatLastSeenRecently = "ostatnio widziany niedawno"
    override val chatNotificationsLabel = "Powiadomienia"
    override val chatTabMembers = "Członkowie"
    override val chatTabMedia = "Multimedia"
    override val chatTabFiles = "Pliki"
    override val chatTabLinks = "Linki"
    override val chatLoading = "Wczytywanie..."
    override val chatNoMediaYet = "Na razie brak multimediów"
    override val chatNoFilesYet = "Na razie brak plików"
    override val chatUnknownFile = "Nieznany plik"
    override val chatNoLinksYet = "Na razie brak linków"
    override val chatNoMembers = "Brak członków"
    override val chatRoleOwner = "Właściciel"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "edytowano"
    override val chatFileFallback = "Plik"
    override val chatMenuReply = "Odpowiedz"
    override val chatMenuPin = "Przypnij"
    override val chatEmptyTitle = "Na razie brak czatów"
    override val chatEmptySubtitle = "Rozpocznij rozmowę, aby zobaczyć tutaj swoje wiadomości."
    override val chatUnnamed = "Bez nazwy"
    override val chatNoMessagesYet = "Na razie brak wiadomości"
    override val chatRoomEmptyTitle = "Na razie brak wiadomości"
    override val chatRoomEmptySubtitle = "Przywitaj się i rozpocznij rozmowę."
    override fun chatMembersHeader(count: Int) = "Członkowie ($count)"
    override val chatNoMediaSharedYet = "Brak udostępnionych multimediów"
    override val chatNoFilesSharedYet = "Brak udostępnionych plików"
    override val chatNoLinksSharedYet = "Brak udostępnionych linków"

    // widget
    override val widgetDismiss = "Zamknij"
    override val widgetSomethingWentWrong = "Coś poszło nie tak"
    override val widgetTryAgain = "Spróbuj ponownie"
    override val widgetCookieTitle = "Używamy plików cookie"
    override val widgetCookieMessage = "Ta strona używa plików cookie, aby zapewnić Ci jak najlepsze wrażenia."
    override val widgetCookieDecline = "Odrzuć"
    override val widgetCookieAccept = "Akceptuj"
    override val widgetAddInterval = "Dodaj przedział"
    override val widgetSendMessage = "Wyślij wiadomość"
    override val widgetPrevious = "Poprzednia"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Aktywny"
    override val widgetStatusDebtor = "Dłużnik"
    override val widgetStatusInactive = "Nieaktywny"
    override val widgetUnpaid = "nieopłacone"
    override val widgetStatusInProgress = "W trakcie"
    override val widgetStatusUpcoming = "Nadchodzące"
    override val widgetStatusPending = "Oczekujące"
    override val widgetStatusCompleted = "Zakończone"
    override fun widgetFieldLabel(number: String) = "Kort $number"
    override val widgetYearly = "Rocznie"
    override val widgetAllFields = "Wszystkie korty"
    override val widgetPreviousMonth = "Poprzedni miesiąc"
    override val widgetNextMonth = "Następny miesiąc"
    override val widgetSortAscending = "Sortuj rosnąco"
    override val widgetSortDescending = "Sortuj malejąco"
    override val widgetChecked = "Zaznaczone"

    // form
    override val formSelectPlaceholder = "Wybierz..."

    // common
    override val commonCancel = "Anuluj"
    override val commonErrorConnection = "Problem z połączeniem. Sprawdź internet i spróbuj ponownie."
    override val commonSave = "Zapisz"
    override val commonDelete = "Usuń"
    override val commonEdit = "Edytuj"
    override val commonNext = "Dalej"
    override val commonRetry = "Ponów"
    override val commonSearch = "Szukaj"

    // event
    override val eventMatchEndedTitle = "MECZ ZAKOŃCZONY"
    override val eventMatchEndedSubtitle = "Oceń graczy, aby zaktualizować ich osobiste rankingi."
    override val eventTabMatchInfo = "Info o meczu"
    override val eventTabLineups = "Składy"
    override val eventTabMedia = "Multimedia"
    override val eventCreateTeam = "Utwórz drużynę"
    override val eventCancelEventQuestion = "Odwołać wydarzenie?"
    override val eventDeleteEventQuestion = "Usunąć wydarzenie?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" zostanie oznaczone jako odwołane."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" zostanie trwale usunięte."
    override val eventCancelNoticeParticipants = "Pozostali uczestnicy zostaną powiadomieni. Czat i historia pozostaną dostępne."
    override val eventDeleteNoticeMedia = "Zdjęcie wydarzenia i czat również zostaną usunięte."
    override val eventKeepEvent = "Zachowaj wydarzenie"
    override val eventCancelling = "Odwoływanie..."
    override val eventDeleting = "Usuwanie..."
    override val eventCancelEvent = "Odwołaj wydarzenie"
    override val eventMatchPerformanceTitle = "Występ w meczu"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Stat"
    override val eventProPlusStatDescription = "Szczegółowa celność strzałów, skuteczność podań i posiadanie piłki."
    override val eventLoadingMedia = "Wczytywanie multimediów..."
    override val eventDeleteMediaQuestion = "Usunąć plik?"
    override val eventDeleteMediaMessage = "Ten plik zostanie usunięty z wydarzenia dla wszystkich."
    override val eventNoMediaYet = "Na razie brak multimediów"
    override val eventNoMediaDescription = "Zdjęcia i filmy z tego meczu pojawią się tutaj."
    override val eventInviteTeamTitle = "Zaproś drużynę"
    override val eventSearchTeamsLabel = "Szukaj drużyn"
    override val eventSearchTeamsPlaceholder = "Wpisz nazwę drużyny..."
    override val eventSearching = "Wyszukiwanie..."
    override val eventNoTeamsFound = "Nie znaleziono drużyn"
    override fun eventTeamRating(rating: String) = "Rating $rating"
    override fun eventTeamMembersCount(count: Int) = "$count członków"
    override val eventInviteStatusAccepted = "Zaakceptowano"
    override val eventInviteStatusDeclined = "Odrzucono"
    override val eventInviteStatusInvited = "Zaproszono"
    override val eventInvite = "Zaproś"
    override val eventStartEventQuestion = "Rozpocząć wydarzenie?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" rozpocznie się na żywo."
    override val eventStartNotice = "Zapisy zostaną zamknięte i mecz się rozpocznie."
    override fun eventPendingRequestOne(count: Int) = "$count oczekująca prośba"
    override fun eventPendingRequestsMany(count: Int) = "$count oczekujących próśb"
    override val eventPendingRequestsSubtitle = "Ci gracze poprosili o dołączenie, ale nie zostali jeszcze zatwierdzeni."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count gracz bez drużyny"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count graczy bez drużyny"
    override val eventTeamlessSubtitle = "Są potwierdzeni, ale nieprzypisani do żadnej drużyny."
    override val eventStarting = "Rozpoczynanie..."
    override val eventStartAnyway = "Rozpocznij mimo to"
    override val eventMonthJanuary = "Styczeń"
    override val eventMonthFebruary = "Luty"
    override val eventMonthMarch = "Marzec"
    override val eventMonthApril = "Kwiecień"
    override val eventMonthMay = "Maj"
    override val eventMonthJune = "Czerwiec"
    override val eventMonthJuly = "Lipiec"
    override val eventMonthAugust = "Sierpień"
    override val eventMonthSeptember = "Wrzesień"
    override val eventMonthOctober = "Październik"
    override val eventMonthNovember = "Listopad"
    override val eventMonthDecember = "Grudzień"
    override val eventVs = "vs"
    override val eventTeamsLabel = "drużyny"
    override val eventPlayersLabel = "gracze"
    override val eventProBadge = "PRO"
    override val eventProInfoSquadsTitle = "Twórz składy i zarządzaj nimi."
    override val eventProInfoSquadsDesc = "Zbierz najlepszy skład i poprowadź drużyny do zwycięstwa."
    override val eventProInfoStatsTitle = "Zapisuj statystyki meczu"
    override val eventProInfoStatsDesc = "Rejestruj na żywo wyniki, gole, asysty i osiągnięcia zawodników."
    override val eventProInfoResultsTitle = "Analizuj wyniki meczu"
    override val eventProInfoResultsDesc = "Wskaż najskuteczniejszych strzelców i najlepszych zawodników meczu."
    override val eventCompletedBadge = "Zakończone"
    override val eventLeadersEmptyWinGame = "Wygraj gema, aby piąć się w rankingu."
    override val eventLeadersEmptyFirstScore = "Zdobądź pierwszy punkt i zostań liderem rankingu."
    override val eventLeadersEmptyTakeSet = "Wygraj seta, aby zgarnąć pierwsze miejsce."
    override val eventLeadersEmptyFirstAssist = "Jako pierwszy zalicz zwycięską asystę."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Gracz"
    override val eventCreateTeamSubtitle = "Skompletuj swoją ekipę na mecz"
    override val eventTeamNameLabel = "Nazwa drużyny"
    override val eventTeamNameRequired = "Nazwa drużyny jest wymagana"
    override val eventTeamColorLabel = "Kolor drużyny"
    override val eventTeamColorSubtitle = "Wybierz kolor swojej drużyny"
    override val eventTeamNamePlaceholder = "Wpisz nazwę drużyny..."
    override val eventChatTitle = "Czat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Gracze"
    override val eventChatWaitingApproval = "Oczekiwanie na zatwierdzenie"
    override val eventChatConfirmingSpot = "Potwierdzanie Twojego miejsca"
    override val eventChatLocked = "Czat jest zablokowany"
    override val eventChatWaitingApprovalSubtitle = "Gdy admin potwierdzi Twoją prośbę, otworzy się czat z drużyną."
    override val eventChatConfirmingSpotSubtitle = "Twoja prośba o dołączenie jest przetwarzana. Czat odblokuje się, gdy tylko dołączysz."
    override val eventChatPrivateSubtitle = "To wydarzenie jest prywatne. Poproś o dołączenie i poczekaj na zgodę admina."
    override val eventChatLockedSubtitle = "Aby zobaczyć rozmowę i pisać z innymi graczami, musisz dołączyć do tego meczu."
    override val eventJoinEvent = "Dołącz do wydarzenia"
    override val eventChatNoMessages = "Na razie brak wiadomości"
    override val eventChatNoMessagesSubtitle = "Rozpocznij rozmowę ze swoją drużyną."
    override val eventTeamSectionTitle = "Drużyna"
    override val eventDeleteTeam = "Usuń drużynę"
    override val eventViewProfile = "Zobacz profil"
    override val eventRemoveAdmin = "Odbierz uprawnienia admina"
    override val eventMakeAdmin = "Mianuj adminem"
    override val eventRemoveFromTeam = "Usuń z drużyny"
    override val eventRemoveFromEvent = "Usuń z wydarzenia"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count drużyn"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max graczy"
    override fun eventPlayersCount(count: Int) = "$count graczy"
    override val eventStatusLive = "Live"
    override val eventLeave = "Opuść"
    override val eventStart = "Rozpocznij"
    override val eventJoin = "Dołącz"
    override val eventStatusPending = "Oczekuje"
    override val eventStatusCanceled = "Odwołane"
    override val eventPendingApprovalBadge = "Oczekuje na zatwierdzenie"
    override val eventRatePerformanceTitle = "Oceń występ"
    override val eventRateVoteCounts = "Twój głos się liczy!"
    override val eventCommunityRating = "Ocena społeczności"
    override val eventSubmitRating = "Wyślij ocenę"
    override val eventSubmitting = "Wysyłanie..."
    override val eventAddMediaTitle = "Dodaj multimedia"
    override val eventUploadMedia = "Prześlij multimedia"
    override val eventDropMediaHere = "Upuść tutaj zdjęcie lub film"
    override val eventMaxFileSize = "maks. 30 MB"
    override val eventSelectedLabel = "Wybrane"
    override val eventClearAll = "Wyczyść wszystko"
    override val eventAddToTeam = "Dodaj do drużyny"
    override val eventMakeSubstitution = "Wykonaj zmianę"
    override val eventViewProfileSheet = "Zobacz profil"
    override fun eventSwapWith(name: String) = "Zamień $name z"
    override val eventEndMatch = "Zakończ mecz"
    override val eventReset = "Resetuj"
    override val eventLeadersEmptyWinGameShort = "Wygraj gema, aby piąć się w rankingu"
    override val eventLeadersEmptyScoreFirst = "Zdobądź pierwszy punkt i zostań liderem rankingu"
    override val eventLeadersEmptyTakeSetShort = "Wygraj seta, aby zgarnąć pierwsze miejsce"
    override val eventLeadersEmptyWinningAssist = "Zalicz zwycięską asystę"
    override val eventRatePlayersSubtitle = "Oceń graczy, aby zaktualizować ranking Top"
    override val eventGenericError = "Coś poszło nie tak"
    override val eventDeleteTeamQuestion = "Usunąć drużynę?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" zostanie usunięta z tego wydarzenia. Przypisani do niej gracze pozostaną bez przydziału."
    override val eventPlayersTitle = "Gracze"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total zatwierdzonych)"
    override val eventAwaitingPlayers = "Oczekiwanie na graczy"
    override val eventAwaitingPlayersSubtitle = "Dołącz do wydarzenia już teraz, aby zacząć tworzyć drużyny."
    override val eventAssignToTeam = "Przypisz do drużyny"
    override val eventFormatLabel = "Format:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Oś czasu"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Trener"
    override val eventSaving = "Zapisywanie..."
    override val eventCreating = "Tworzenie..."
    override val eventSaveChanges = "Zapisz zmiany"
    override val eventCreateEvent = "Utwórz wydarzenie"
    override val eventEditEventTitle = "Edytuj wydarzenie"
    override val eventErrorTitleRequired = "Tytuł jest wymagany"
    override val eventErrorSportRequired = "Sport jest wymagany"
    override val eventErrorSportNameRequired = "Nazwa sportu jest wymagana"
    override val eventErrorFormatRequiredPro = "Format jest wymagany dla wydarzeń Pro"
    override val eventErrorStartTimeRequired = "Godzina rozpoczęcia jest wymagana"
    override val eventErrorEndTimeRequired = "Godzina zakończenia jest wymagana"
    override val eventErrorEndAfterStart = "Godzina zakończenia musi być późniejsza niż rozpoczęcia"
    override val eventErrorStartInPast = "Godzina rozpoczęcia nie może być w przeszłości"
    override val eventErrorSelectAddress = "Wybierz adres"
    override val eventErrorAddressCity = "Wybierz prawidłowy adres zawierający miasto"
    override val eventErrorCoverRequired = "Zdjęcie okładki jest wymagane"
    override val eventErrorSignInEdit = "Zaloguj się, aby edytować wydarzenia"
    override val eventErrorSignInCreate = "Zaloguj się, aby tworzyć wydarzenia"
    override val eventErrorUploadImage = "Nie udało się przesłać zdjęcia"
    override val eventErrorSaveChanges = "Nie udało się zapisać zmian"
    override val eventErrorCreateEvent = "Nie udało się utworzyć wydarzenia"
    override val eventAddressLabel = "Adres"
    override val eventAddressPlaceholder = "Szukaj adresu..."
    override val eventTitleLabel = "Tytuł"
    override val eventTitlePlaceholder = "np. Niedzielny mecz piłki nożnej"
    override val eventSportNameLabel = "Nazwa sportu"
    override val eventSportNamePlaceholder = "Wpisz nazwę sportu"
    override val eventMaxPlayersLabel = "Maks. liczba graczy"
    override val eventMaxPlayersPlaceholder = "np. 20"
    override val eventDateLabel = "Data"
    override val eventTimeFromLabel = "Od"
    override val eventTimeToLabel = "Do"
    override val eventChooseOnMap = "Wybierz na mapie"
    override val eventConfirmLocation = "Potwierdź lokalizację"
    override val eventAddPhoto = "Dodaj zdjęcie"
    override val eventSportLabel = "Sport"
    override val eventLoading = "Wczytywanie..."
    override val eventSelectSportPlaceholder = "Wybierz sport"
    override val eventCommunityLabel = "Społeczność"
    override val eventCommunityNone = "Brak (publiczne)"
    override val eventUnnamedGroup = "Grupa bez nazwy"
    override val eventFormatFieldLabel = "Format"
    override val eventSelectPlaceholder = "Wybierz"
    override val eventCostLabel = "Koszt"
    override val eventPrivateLabel = "Prywatne"
    override val eventPrivateInfoDescription = "Zarządzaj swoją ekipą, ręcznie zatwierdzając prośby o dołączenie lub usuwając uczestników."

    // subscription
    override val subscriptionTitle = "Arena Access"
    override val subscriptionActive = "Subskrypcja aktywna"
    override val subscriptionPrice = "${'$'}14.99/miesiąc"
    override val subscriptionRequired = "Wykup subskrypcję Arena Access, aby odblokować wydarzenia Pro, awatary AI i wszystkie karty zawodników."
    override val subscribe = "Subskrybuj"
    override val subscriptionProcessing = "Przetwarzanie…"
    override val subscriptionBenefitProEvents = "Twórz wydarzenia Pro"
    override val subscriptionBenefitAvatars = "Generuj awatary AI"
    override val subscriptionBenefitCards = "Odblokuj wszystkie karty zawodników"
    override val cancelSubscription = "Anuluj subskrypcję"
    override val manageSubscription = "Zarządzaj subskrypcją"
    override val subscriptionCanceled = "Twoja subskrypcja została anulowana."
    override val subscriptionActivated = "Arena Access jest już aktywna. Miłego korzystania!"
    override val subscriptionSignInRequired = "Zaloguj się, aby wykupić subskrypcję."
    override val subscriptionCheckoutFailed = "Coś poszło nie tak. Spróbuj ponownie."
    override val subscriptionWillCancel = "Twoja subskrypcja nie zostanie odnowiona."
    override fun subscriptionRenewsOn(date: String) = "Odnowienie $date"
    override fun subscriptionEndsOn(date: String) = "Dostęp do $date"
    override val cardFrozenLabel = "Zamrożona"
    override val cardFrozen = "Odnów, aby odblokować"
    override val cardProPlus = "PRO+"

    // paywall
    override val paywallTitle = "Arena Pro +"
    override val paywallSubtitle = "Graj jak pro. Wyglądaj jak pro."
    override val paywallFeaturePlayerCards = "Ekskluzywne karty gracza"
    override val paywallFeatureAiAvatar = "Generator awatarów AI"
    override val paywallFeatureActivityLifestyle = "Aktywności i lifestyle"
    override val paywallFeatureProEvents = "Twórz wydarzenia Pro i dodawaj media"
    override val paywallFeatureNewsMatches = "Centrum meczowe: składy, statystyki i na żywo"
    override fun paywallUpgradeCta(price: String) = "Ulepsz za ${price}/miesiąc"
    override fun paywallTrialCta(trialPrice: String) = "Aktywuj za $trialPrice"
    override fun paywallTrialTerms(trialPrice: String, price: String) = "Pierwsze 3 dni za $trialPrice, potem ${price}/mies. aż do anulowania."
    override val paywallCancelAnytime = "Anuluj w dowolnym momencie"
    override val paywallAutoRenew = "Odnawia się automatycznie co miesiąc do momentu anulowania."
    override val paywallNewsSubtitle = "Śledź każdy mecz jak pro."
    override val paywallFeatureUnlimitedNews = "Nielimitowany kanał newsów"
    override val paywallFeatureHighlights = "Wideoskróty meczów"
    override val paywallFeatureLineups = "Składy, statystyki i bezpośrednie starcia"
    override val paywallFeatureLiveScores = "Wyniki na żywo i oś czasu meczu"
    override val paywallFeaturePlayerProfiles = "Profile zawodników i forma drużyn"
    override val newsProBannerTitle = "Nie przegap, co będzie dalej"
    override val newsProBannerSubtitle = "Odblokuj pełny kanał — wszystkie newsy, wyniki na żywo, składy i statystyki z Arena Pro +"
    override val newsProBannerCta = "Odblokuj z Arena Pro +"
    override val cardLifeGeneratePro = "Generuj (Pro)"

    // gender
    override val profilePersonalEditGenderLabel = "Płeć"
    override val genderMale = "Mężczyzna"
    override val genderFemale = "Kobieta"

    // nav
    override val navDashboard = "Panel"
    override val navClients = "Klienci"
    override val navChat = "Czat"
    override val navSchedule = "Harmonogram"
    override val navClubSettings = "Ustawienia klubu"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navNews = "Aktualności"
    override val newsEmptyDay = "Brak aktualności na ten dzień"
    override val newsOfDayTitle = "Aktualności dnia"
    override val newsTrendingTitle = "Najczęściej komentowane"
    override val newsAllTitle = "Wszystkie aktualności"
    override val newsSortNew = "Nowe"
    override val newsSortPopular = "Popularne"
    override val newsMatchesTitle = "Mecze"
    override val newsStandingsTitle = "Tabela"
    override val newsMatchOverview = "Przegląd"
    override val newsMatchLineups = "Składy"
    override val newsMatchSubstitutes = "Rezerwowi"
    override val newsMatchStats = "Statystyki"
    override val newsClubSquad = "Skład"
    override val newsClubLastMatches = "Ostatnie mecze"
    override val newsClubNextMatches = "Nadchodzące mecze"
    override val newsClubFounded = "Założony"
    override val newsDetailUnavailable = "Szczegóły niedostępne"
    override val newsWatchOnYoutube = "Obejrzyj w YouTube"
    override val newsArticleMatch = "Mecz"
    override val newsArticleHighlights = "Skrót meczu"
    override val newsMatchH2h = "Bezpośrednie mecze"
    override val newsLeagueAll = "Wszystkie"
    override val newsStPlayed = "M"
    override val newsStWin = "Z"
    override val newsStDraw = "R"
    override val newsStLoss = "P"
    override val newsStPts = "Pkt"
    override val newsNoMatches = "Brak meczów tego dnia"
    override val newsSortLabel = "Sortowanie"
    override val newsSortFavorites = "Ulubione"
    override val newsToday = "Dzisiaj"
    override val newsTomorrow = "Jutro"
    override val newsYesterday = "Wczoraj"
    override val newsFilterFinished = "Zakończone"
    override val newsFilterUpcoming = "Zaplanowane"
    override val newsStGoals = "Bramki"
    override val newsZoneCl = "Liga Mistrzów"
    override val newsZoneEl = "Liga Europy"
    override val newsZoneRelegation = "Spadek"
    override val newsFilterStatusTitle = "Status"
    override val newsFilterLeaguesTitle = "Ligi i turnieje"
    override val newsNextMatches = "Najbliższe mecze"
    override val newsRelatedTitle = "Podobne aktualności"
    override val newsSourceLabel = "Źródło"
    override val navPeople = "Osoby"
    override val navProfile = "Profil"
    override val navStatistic = "Statystyki"
    override val navTeam = "Drużyna"
    override val navMedia = "Multimedia"
    override val navWeek = "Tydzień"
    override val navMonth = "Miesiąc"
    override val navYear = "Rok"

    // modal
    override val modalDecline = "Odrzuć"
    override val modalCompleteSession = "Zakończ sesję"
    override val modalTimeAlt = "Godzina"
    override val modalPriceAlt = "Cena"
    override val modalBookings = "Rezerwacje"
    override val modalTotalSpent = "Łącznie wydane"
    override val modalSendMessage = "Wyślij wiadomość"
    override val modalAddNote = "Dodaj notatkę"
    override val modalAdminNotes = "Notatki admina"
    override val modalAdminNotesPrivacy = "Prywatne — widoczne tylko dla adminów"
    override val modalWriteNotePlaceholder = "Napisz notatkę..."
    override val modalAdd = "Dodaj"
    override val modalBookingHistory = "Historia rezerwacji"
    override val modalNoBookingsYet = "Na razie brak rezerwacji"
    override val modalFieldFallback = "Kort"
    override val modalStatusConfirmed = "Potwierdzona"
    override val modalStatusPending = "Oczekująca"
    override val modalStatusCompleted = "Zakończona"
    override val modalStatusCancelled = "Anulowana"
    override val modalPaid = "Opłacone"
    override val modalUnpaid = "Nieopłacone"

    // feed
    override val feedClubBadge = "Klub"
    override fun feedAddAllPhotos(count: Int) = "Dodaj wszystkie zdjęcia ($count)"
    override val feedUploadFailed = "Przesyłanie nie powiodło się"
    override val feedCreatePostFailed = "Nie udało się utworzyć posta"
    override val feedCreatePostTitle = "Utwórz post"
    override val feedChooseLayoutSubtitle = "Wybierz układ dla swojego posta"
    override val feedFileTooLarge = "Plik jest za duży (maks. 50 MB)"
    override val feedChooseLayout = "Wybierz układ"
    override val feedCreating = "Tworzenie..."
    override val feedAddPhoto = "Dodaj zdjęcie"
    override val feedCityLabel = "Miasto"
    override val feedEnterCityPlaceholder = "Wpisz nazwę miasta..."
    override val feedPostContentLabel = "Treść posta"
    override val feedPostContentPlaceholder = "Napisz coś o tym poście..."
    override val feedOptional = "(Opcjonalnie)"
    override val feedPickPhotoFirst = "Najpierw wybierz zdjęcie"
    override val feedCreateStoryFailed = "Nie udało się utworzyć relacji"
    override val feedCreateStoriesTitle = "Utwórz relację"
    override val feedCreateStoriesSubtitle = "Twórz i udostępniaj swoje momenty"
    override val feedFileTooLargeStory = "Plik jest za duży (maks. 30 MB)"
    override val feedDropContentHere = "Upuść tutaj swoje treści"
    override val feedMaxStorySize = " maks. 30 MB"
    override val feedFollowingSection = "Obserwowani"
    override val feedFollowersSection = "Obserwujący"
    override val feedSearching = "Wyszukiwanie…"
    override val feedNoResults = "Brak wyników"
    override val feedLoadingMore = "Wczytywanie kolejnych…"
    override val feedThisUser = "ten użytkownik"
    override fun feedUnfollowTitle(name: String) = "Przestać obserwować $name?"
    override val feedUnfollowSubtitle = "Możesz zacząć obserwować ponownie w każdej chwili."
    override val feedUnfollow = "Przestań obserwować"
    override fun feedRemoveTitle(name: String) = "Usunąć $name?"
    override val feedRemoveSubtitle = "Nie dostanie powiadomienia, ale nie będzie już widzieć Twoich postów."
    override val feedRemove = "Usuń"
    override val feedFollow = "Obserwuj"
    override val feedDeleted = "Usunięto"
    override val feedNotFollowingTitle = "Nie obserwujesz jeszcze nikogo"
    override val feedNotFollowingBody = "Obserwuj graczy, aby widzieć w swoim feedzie ich najnowsze posty, najlepsze akcje i relacje."
    override val feedNoFollowersTitle = "Na razie brak obserwujących"
    override val feedNoFollowersBody = "Udostępniaj posty i relacje z meczów, aby społeczność Cię zauważyła."
    override val feedDiscoverPlayers = "Odkrywaj graczy"

    // dropdown
    override val dropdownAllCities = "Wszystkie miasta"
    override val dropdownSelectedAlt = "Wybrano"

    // page
    override val pageScheduleTitle = "Harmonogram"
    override val pageScheduleComingSoon = "Widok harmonogramu już wkrótce"
    override val pageEventsSeoTitle = "Wydarzenia sportowe"
    override val pageEventsSeoDescription = "Przeglądaj wydarzenia sportowe w okolicy i dołączaj do nich — piłka nożna, tenis, koszykówka, padel i więcej. Stwórz własny mecz i zapraszaj graczy na Arenie."
    override val pageEventsTitle = "Wydarzenia"
    override val pageCreateEvent = "Utwórz wydarzenie"
    override val pageNoEventsYet = "Na razie brak wydarzeń"
    override val pageNotFoundTitle = "Ups, nie znaleziono strony"
    override val pageNotFoundBody = "Sprawdź, czy adres strony nie zawiera literówek, albo wróć do głównej areny."
    override val pageBackToArena = "Wróć do Areny"
    override val pageChatTitle = "Czaty"
    override val pageLoading = "Wczytywanie..."
    override val pageSomethingWentWrong = "Coś poszło nie tak"
    override fun pageUnfollowTitle(name: String) = "Przestań obserwować $name"
    override val pageRemoveFollowerTitle = "Usunąć obserwującego?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Nie powiadomimy $name o tej zmianie."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "Zobacz, czym żyje sportowa społeczność Areny — wyniki meczów, najlepsze akcje i momenty udostępniane przez graczy w Twojej okolicy."
    override val pageNoPostsYet = "Na razie brak postów"
    override val pageLoadingMore = "Wczytywanie kolejnych..."
    override val pagePeopleSeoTitle = "Znajdź graczy"
    override val pagePeopleSeoDescription = "Odkrywaj sportowców w okolicy, dopasuj się do graczy na swoim poziomie i zbierz ekipę na kolejny mecz na Arenie."
    override val pagePeopleTitle = "Osoby"
    override val pageSquadUpTitle = "Zbierz ekipę"
    override val pageSquadUpSubtitle = "Znajdź partnerów, poznawaj graczy i zacznij grę."
    override val pagePeopleLoadFailed = "Nie udało się wczytać osób"
    override val pagePeopleCaughtUpTitle = "Na razie to już wszyscy"
    override val pagePeopleCaughtUpSubtitle = "Wróć później po kolejnych graczy."
    override val pageRefresh = "Odśwież"
    override val pageClientsTitle = "Klienci"
    override fun pageClientsTotal(total: Int) = "$total klientów łącznie"
    override val pageActiveClients = "Aktywni klienci"
    override val pageTotalBookings = "Łączna liczba rezerwacji"
    override val pageTotalRevenue = "Łączny przychód"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Aktywny"
    override val pageStatusDebtor = "Dłużnik"
    override val pageStatusAll = "Wszystkie statusy"
    override val pageStatusInactive = "Nieaktywny"
    override val pageAddNewClient = "Dodaj nowego klienta"
    override val pageColName = "Imię i nazwisko"
    override val pageColRevenue = "Przychód"
    override val pageColStatus = "Status"
    override val pageColLastVisit = "Ostatnia wizyta"
    override val pageColActions = "Akcje"
    override val pageUnpaidSuffix = "nieopłacone"
    override val pagePrevious = "Poprzednia"
    override val pagePageLabel = "Strona"
    override val pageOfLabel = "z"
    override val pageBackToEvents = "Wróć do wydarzeń"
    override val pageBackToClubs = "Wróć do klubów"
    override val pageResetTimerTitle = "Zresetować stoper?"
    override val pageResetTimerMessage = "Zegar meczowy wróci do 00:00. Zapisane statystyki pozostaną bez zmian."
    override val pageResetTimerConfirm = "Resetuj"
    override val pageResetting = "Resetowanie..."
    override val pageEndMatchTitle = "Zakończyć mecz?"
    override val pageEndMatchMessage = "Wydarzenie zostanie oznaczone jako zakończone, a wyniki zostaną zablokowane."
    override val pageEndMatchConfirm = "Zakończ mecz"
    override val pageEnding = "Kończenie..."
    override val pageAddMedia = "Dodaj multimedia"
    override val pageBook = "Zarezerwuj"
    override val pageCourtRules = "Zasady korzystania z kortu"
    override val pageNoCourtRules = "Nie określono zasad korzystania z kortu."
    override val pageLeaveReview = "Zostaw opinię"
    override val pageNoReviewsYet = "Na razie brak opinii."
    override val pageSportFootball = "Piłka nożna"
    override val pageSportBasketball = "Koszykówka"
    override val pageSportTennis = "Tenis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Klub"
    override fun pageReviewExperienceTitle(sportName: String) = "$sportName — jak wrażenia?"
    override val pageWriteReviewPlaceholder = "Napisz swoją opinię..."
    override val pagePosting = "Publikowanie..."
    override val pagePostReview = "Opublikuj opinię"
    override val pageLoadMore = "Wczytaj więcej"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Twoja sportowa kariera w pigułce — statystyki, ratingi i osiągnięcia w piłce nożnej, tenisie, koszykówce i nie tylko na Arenie."
    override val pageEventsTab = "Wydarzenia"
    override val pageClubsTab = "Kluby"
    override val pageFilterLocation = "Lokalizacja"
    override val pageUnnamedCommunity = "Bez nazwy"
    override val pageFilterCommunity = "Społeczność"
    override val pageFilterAll = "Wszystkie"
    override val pageFilterCalendar = "Kalendarz"
    override val pageAddEvent = "Dodaj wydarzenie"
    override val pageAddClub = "Dodaj klub"
    override val pageMap = "Mapa"
    override val pageList = "Lista"
    override val pageOwnTheArena = "PRZEJMIJ ARENĘ"
    override val pageArenaBannerSubtitle = "Twoja arena czeka. Rezerwuj od ręki i graj bez stresu."
    override val pageLoadingMoreEvents = "Wczytywanie kolejnych wydarzeń..."
    override val pageLoadingMoreClubs = "Wczytywanie kolejnych klubów..."
    override val pageNoClubsYet = "Na razie brak klubów"
    override val pageClubsWillAppear = "Kluby pojawią się tutaj"
    override val pageEventsMapTitle = "Mapa wydarzeń"
    override val pageClubsMapTitle = "Mapa klubów"
    override val pageDeleteClub = "Usuń klub"
    override val pageAddBanner = "Dodaj baner"
    override val pageRulePlaceholder = "np. Wymagany strój sportowy"
    override val pageAddRule = "Dodaj zasadę"
    override val pageEditServices = "Edytuj usługi"
    override val pageManageServices = "Zarządzaj usługami"
    override val pageAmenityParking = "Parking"
    override val pageAmenityCafe = "Kawiarnia"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Recepcja"
    override val pageAmenityShower = "Prysznic"
    override val pageAmenityFirstAid = "Pierwsza pomoc"
    override val pageReviewsLabel = "Opinie:"
    override val pageAvgRatingLabel = "Śr. ocena:"
    override val pageReviewsPlaceholderNote = "Opinie pojawią się tutaj, gdy użytkownicy zostawią swoje oceny."
    override val pageClubComposePrompt = "Co słychać w Twoim klubie?"
    override val pageClubNoPostsHint = "Udostępnij zdjęcie i krótką myśl, aby klub był aktywny."
    override val pageComposePostTitle = "Napisz post"
    override val pagePostContentPlaceholder = "Treść posta..."
    override fun pageAddImageSlot(slot: Int) = "Dodaj zdjęcie $slot"
    override val pagePostAction = "Opublikuj"
    override val pageEditClubInfo = "Edytuj informacje o klubie"
    override val pageClubNameLabel = "Nazwa klubu"
    override val pageAddressLabel = "Adres"
    override val pageSearchAddressPlaceholder = "Szukaj adresu"
    override val pageSaveChanges = "Zapisz zmiany"

    // account
    override val accountRequiredTitle = "Wymagane konto"
    override val accountRequiredDescription = "Ta funkcja jest tylko dla zarejestrowanych graczy. Zaloguj się przez Google lub Apple, aby kontynuować."
    override val accountRequiredTermsPrefix = "Kontynuując, akceptujesz nasze "
    override val accountRequiredTerms = "Warunki"
    override val accountRequiredPrivacy = "Prywatność"

    // avatar
    override val avatarGenTitle = "Awatar AI"
    override val avatarGenErrorFileType = "Dozwolone są tylko pliki JPEG, PNG i WebP"
    override val avatarGenErrorFileSize = "Rozmiar pliku musi być mniejszy niż 30 MB"
    override val avatarGenErrorNoPerson = "Nie znaleźliśmy osoby na tym zdjęciu. Spróbuj z innym."
    override val avatarGenErrorFailed = "Generowanie nie powiodło się. Spróbuj z innym zdjęciem lub promptem."
    override val avatarGenGenerating = "Generowanie…"
    override val avatarGenGeneratingHint = "To może potrwać do 30 sekund"
    override val avatarGenGenerate = "Generuj"
    override val avatarGenGeneratedLook = "Wygenerowany wygląd"
    override val avatarGenDropPhotoHere = "Upuść tutaj swoje zdjęcie"
    override val avatarGenMaxFileSize = "maks. 30 MB"
    override val avatarGenReadyToGenerate = "Gotowe do generowania"
    override val avatarGenCustomPrompt = "Własny prompt"
    override val avatarGenPromptPlaceholder = "Dodaj szczegóły, aby ustawić styl ..."
    override val avatarGenInfoDefaultBehavior = "Domyślnie AI wytnie Cię ze zdjęcia i umieści na karcie."
    override val avatarGenInfoPromptIntro = "W prompcie możesz też poprosić o:"
    override val avatarGenInfoBulletZoom = "Przybliżenie lub oddalenie postaci"
    override val avatarGenInfoBulletObject = "Dodanie lub usunięcie obiektu (np. okulary przeciwsłoneczne, koszulka, piłka, czapka)"
    override val avatarGenOptionalBadge = "(Opcjonalnie)"

    // card
    override val cardLifeTitle = "Ożyw swoją kartę"
    override val cardLifeSubtitle = "Stwórz swoją wizualną tożsamość"
    override val cardLifeMyStyles = "Moje style"
    override val cardLifeSelectToGenerate = "Wybierz, aby generować"
    override val cardLifeActiveCards = "Aktywne karty profilu"
    override val cardLifeDragToReorder = "Przeciągnij, aby zmienić kolejność"
    override val cardLifeNoTemplates = "Na razie brak szablonów kart. Zajrzyj do sklepu z kartami."
    override val cardLifeCreatePhoto = "Utwórz zdjęcie"
    override val cardLifeDeleteCardTitle = "Usunąć kartę?"
    override val cardLifeDeleteCardMessage = "Karta zostanie usunięta z Twojej galerii. Szablon pozostanie w Twoich stylach."

    // complete
    override val completeProfileTitle = "Uzupełnij profil, aby zacząć przesuwać"
    override val completeProfileDescription = "Uzupełnij profil, aby zobaczyć graczy o podobnym poziomie i wspólnych zainteresowaniach."
    override val completeProfileMaybeLater = "Może później"
    override val completeProfileAction = "Uzupełnij profil"

    // preference
    override val preferenceDetailsTitle = "Szczegóły preferencji"

    // follow
    override val followListFollowers = "Obserwujący"
    override val followListFollowing = "Obserwowani"
    override val followListNoResults = "Brak wyników"
    override val followListNoFollowersYet = "Na razie brak obserwujących"
    override val followListNotFollowingAnyoneYet = "Nie obserwujesz jeszcze nikogo"
    override val followListUnfollow = "Przestań obserwować"
    override val followListFollow = "Obserwuj"
    override val followListRemove = "Usuń"
    override val followListDeleted = "Usunięto"

    // interactions
    override val interactionsTitle = "Interakcje"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes nowych polubień · $matches dopasowań"
    override val interactionsNewLikes = "Nowe polubienia"
    override val interactionsNoNewLikesTitle = "Na razie brak nowych polubień"
    override val interactionsNoNewLikesMessage = "Gdy ktoś przesunie Cię na Tak, pojawi się tutaj."
    override val interactionsMatches = "Dopasowania"
    override val interactionsNoMatchesTitle = "Na razie brak dopasowań"
    override val interactionsNoMatchesMessage = "Przesuń na Tak kogoś, kto już Cię polubił, aby zgarnąć dopasowanie."

    // match
    override val matchItsWord = "To"
    override val matchWord = "MATCH"
    override val matchSubtitle = "Czas się poznać i zaplanować waszą grę."
    override val matchKeepSwiping = "Przesuwaj dalej"
    override val matchGoToProfile = "Przejdź do profilu"
    override val matchYouFallback = "Ty"

    // purchase
    override val purchaseCardTitle = "Chcesz tę kartę?"
    override val purchaseCardBuying = "Kupowanie…"
    override val purchaseCardBuyNow = "Kup teraz"

    // post
    override val postCommentsLike = "Polub"
    override val postCommentsOneLike = "1 polubienie"
    override fun postCommentsLikes(count: Int) = "$count polubień"
    override val postCommentsInputPlaceholder = "Napisz wiadomość…"

    // story
    override fun storySeenBy(count: Int) = "Widziało $count"

    // support
    override val supportTitle = "Skontaktuj się z pomocą"
    override val supportIntro = "Napisz, co poszło nie tak lub w czym potrzebujesz pomocy — odpowiemy Ci mailem."
    override val supportEmailLabel = "Twój e-mail"
    override val supportMessageLabel = "Wiadomość"
    override val supportMessagePlaceholder = "Opisz swój problem…"
    override val supportErrorInvalidEmail = "Podaj prawidłowy adres e-mail."
    override val supportErrorEmptyMessage = "Napisz wiadomość."
    override val supportErrorGeneric = "Coś poszło nie tak. Spróbuj ponownie."
    override val supportSending = "Wysyłanie…"
    override val supportSendMessage = "Wyślij wiadomość"
    override val supportSentTitle = "Wiadomość wysłana!"
    override val supportSentMessage = "Dzięki za wiadomość — wkrótce odpowiemy na Twój e-mail."

    // person
    override val personDetailTabAbout = "Informacje"
    override val personDetailTabPosts = "Posty"
    override val personDetailTabAchievement = "Osiągnięcia"
    override val personDetailAchievementsComingSoon = "Osiągnięcia już wkrótce."
    override val personDetailFollowing = "Obserwowani"
    override val personDetailFollowers = "Obserwujący"
    override val personDetailSportLabel = "Sport:"
    override val personDetailActivityLabel = "Aktywność:"
    override val personDetailLifestyleLabel = "Styl życia:"
    override val personDetailNoPostsTitle = "Na razie brak postów"
    override val personDetailNoPostsMessage = "Ten gracz jeszcze niczego nie opublikował."

    // common
    override val commonClose = "Zamknij"
    override val commonDone = "Gotowe"
    override val commonLoading = "Wczytywanie…"
    override val commonBack = "Wstecz"
    override val commonSkip = "Pomiń"

    // profile
    override val profileCardShopLoading = "Wczytywanie..."
    override val profileCardShopEmpty = "Brak dostępnych kart"
    override val profileCardShopBuy = "Kup"
    override val profileCardShopFree = "Za darmo"
    override val profileFormationReservePlate = "Rez"
    override val profileFormationCoach = "Trener"
    override val profileMediaEmpty = "Na razie brak multimediów"
    override val profileMediaImageAlt = "multimedia"
    override val profileNewsPrompt = "Co Ci chodzi po głowie?"
    override val profileNewsLoading = "Wczytywanie..."
    override val profileNewsLoginRequired = "Zaloguj się, aby zobaczyć swoje posty"
    override val profileNewsEmpty = "Na razie brak postów. Udostępnij coś!"
    override val profileNewsPlaceholder = "Napisz coś..."
    override val profileNewsPosting = "Publikowanie..."
    override val profileNewsPost = "Opublikuj"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Ostatnie wydarzenia"
    override val profileRecentMatchesEmptyTitle = "Na razie brak zaplanowanych wydarzeń"
    override val profileRecentMatchesEmptyHint = "Wybierz nadchodzące wydarzenie i dołącz do gry!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Drużyna A"
    override val profileRecentMatchesTeamB = "Drużyna B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count os."
    override val profileRecentMatchesWin = "Wygrana"
    override val profileRecentMatchesLoss = "Porażka"
    override val profileRecentMatchesDraw = "Remis"
    override val profileRecentMatchesSportFallback = "Sport"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Format $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count członków"
    override val profileShortcutStatistic = "Statystyki"
    override val profileShortcutMedia = "Multimedia"
    override val profileStatsChartsGoals = "Gole"
    override val profileStatsChartsAssists = "Asysty"
    override val profileStatsChartsPerYear = "rocznie"
    override val profileStatsChartsPerWeek = "tygodniowo"
    override val profileStatsChartsPerMonth = "miesięcznie"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Brak danych"
    override val profileTeamEmptyOwnTitle = "Nie masz jeszcze drużyny"
    override val profileTeamEmptyOtherTitle = "Brak drużyny"
    override val profileTeamEmptyCreateTeam = "Utwórz drużynę"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Mapa świata"
    override val profileTeamMatchesEmpty = "Na razie brak meczów"
    override val profileTeamMatchesUpcomingTitle = "Nadchodzące mecze"
    override val profileTeamMatchesUpcomingEmpty = "Brak nadchodzących meczów"
    override val profileTeamMatchesVenueAlt = "Obiekt"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count drużyn"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total członków"
    override fun profileTeamMatchesFormat(format: Int) = "Format ${format}x${format}"
    override val profileTeamOverviewTitle = "Przegląd drużyny"
    override val profileTeamOverviewClubTitle = "Klub piłkarski"
    override val profileTeamOverviewRating = "Rating"
    override val profileTeamOverviewTeamRating = "Rating drużyny"
    override val profileTeamOverviewStatistics = "Statystyki"
    override val profileTeamOverviewWins = "Wygrane"
    override val profileTeamOverviewDraws = "Remisy"
    override val profileTeamOverviewLosses = "Porażki"
    override val profileSidebarTitle = "Przegląd"
    override val profileSidebarFollowing = "Obserwowani"
    override val profileSidebarFollowers = "Obserwujący"
    override val profileSidebarAchievement = "Osiągnięcia"
    override val profileSidebarAboutYouEmpty = "Dodaj kilka słów o sobie, aby przedstawić swój profil"
    override val profileSidebarFocusActivities = "Zainteresowania i aktywności"
    override val profileSidebarSportLabel = "Sport"
    override val profileSidebarActivityLabel = "Aktywność"
    override val profileSidebarLifestyleLabel = "Styl życia"
    override val profileSidebarChat = "Czat"
    override val profileSidebarFollow = "Obserwuj"
    override val profileSidebarUnfollow = "Przestań obserwować"
    override val profileSidebarNoInterests = "Brak dodanych zainteresowań"
    override val profileSidebarNoInterestsBody = "Pokaż innym swoje hobby i sporty."
    override val profileHubTitle = "Player Hub"
    override val profileHubYourStories = "Twoje relacje"
    override val profileHubStories = "Relacje"
    override val profileHubCardShopUnavailable = "Sklep z kartami niedostępny"
    override val profileHubCardShopTitle = "Sklep z kartami"
    override val profileHubCardShopSubtitle = "Kupuj nowe karty. Określ swój styl."
    override val profileHubActiveBought = "Aktywne i kupione"
    override fun profileHubOwnedCount(count: Int) = "Posiadane: $count"
    override val profileHubNoCardsYet = "Na razie brak kart"
    override val profileHubAvailableForPurchase = "Dostępne do kupienia"
    override val profileHubNewDesignsRegularly = "Regularnie nowe wzory"
    override val profileHubAllCardsOwned = "Masz już wszystkie karty"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat na $period"
    override val profileHubNoChartsTitle = "Brak dostępnych wykresów"
    override val profileHubNoChartsBody = "Wybierz konkretny sport w nagłówku, aby zobaczyć gole, asysty, mecze i resztę swoich statystyk."
    override val profileHubContentTitle = "Treści"
    override val profileHubLoading = "Wczytywanie..."
    override val profileHubAddStory = "Dodaj relację"
    override val profileHubAddPost = "Dodaj post"
    override val profileHubUserFallback = "użytkownik"
    override val profileHubNoPostsYet = "Na razie brak postów"
    override val profileHubShareFirstMoment = "Udostępnij swój pierwszy moment"
    override val profileHubPlayerNotPosted = "Ten gracz jeszcze nic nie opublikował."
    override val profileOverviewTitle = "Przegląd gracza"
    override val profileOverviewPlayerIdentify = "Tożsamość gracza"
    override val profileOverviewChat = "Czat"
    override val profileOverviewAiAvatar = "Awatar AI"
    override val profileOverviewGoals = "Gole"
    override val profileOverviewGoalsUnit = "goli"
    override val profileOverviewWins = "Wygrane"
    override val profileOverviewWinsUnit = "wygranych"
    override val profileOverviewDraws = "Remisy"
    override val profileOverviewDrawsUnit = "remisów"
    override val profileOverviewLosses = "Porażki"
    override val profileOverviewLossesUnit = "porażek"
    override val profileOverviewAchievements = "Osiągnięcia"
    override val profileOverviewNotFollowingAnyone = "Nie obserwujesz jeszcze nikogo"
    override val profileOverviewComingSoon = "Już wkrótce"
    override val profileAwardsEmpty = "Brak nagród"
    override val awardWelcomeTitle = "Nagroda powitalna"
    override val awardTermScorerFootball = "Najlepszy strzelec"
    override val awardTermAssistFootball = "Najlepszy asystent"
    override val awardTermScorerBasketball = "Najlepszy punktujący"
    override val awardTermAssistBasketball = "Najlepszy asystent"
    override val awardTermScorerTennis = "Najwięcej winnerów"
    override val awardTermAssistTennis = "Najwięcej asów"
    override val awardTermScorerVolleyball = "Najlepszy atakujący"
    override val awardTermAssistVolleyball = "Najlepszy asystent"
    override val awardTermScorerPadel = "Najwięcej winnerów"
    override val awardTermAssistPadel = "Najwięcej smeczy"
    override val awardTermScorerGeneric = "Najlepszy strzelec"
    override val awardTermAssistGeneric = "Najlepszy asystent"
    override val awardRank1 = "1. miejsce"
    override val awardRank2 = "2. miejsce"
    override val awardRank3 = "3. miejsce"
    override val profileOverviewAddPost = "Dodaj post"
    override val profileOverviewWritePlaceholder = "Napisz coś..."
    override val profileOverviewPost = "Opublikuj"
    override val profileOverviewLoading = "Wczytywanie..."
    override val profileOverviewLoginToSeePosts = "Zaloguj się, aby zobaczyć posty"
    override val profileOverviewNoPostsYet = "Na razie brak postów"
    override val profileWizardLetsGo = "Zaczynamy!"
    override val profileWizardStepPersonalInfoTitle = "Dane osobowe"
    override val profileWizardStepPersonalInfoDescription = "Opowiedz o sobie, aby zacząć."
    override val profileWizardStepFocusTitle = "Zainteresowania i aktywności"
    override val profileWizardStepFocusDescription = "Wybierz swoje sporty i styl życia"
    override val profileWizardStepCardTitle = "Ożyw swoją kartę"
    override val profileWizardStepCardDescription = "Stwórz swoją wizualną tożsamość"
    override fun profileWizardSelectedCount(count: Int) = "Wybrano: $count"
    override val profileWizardPublicInfo = "Informacje publiczne"
    override val profileWizardMyStyles = "Moje style"
    override val profileWizardSelectToGenerate = "Wybierz, aby generować"
    override val profileWizardNoTemplates = "Brak dostępnych szablonów kart."
    override val profileWizardActiveCards = "Aktywne karty profilu"
    override val profileWizardDragToReorder = "Przeciągnij, aby zmienić kolejność"
    override fun profileWizardCardCount(count: Int) = if (count == 1) "1 karta" else "$count kart"
    override val profileWizardCreatePhoto = "Utwórz zdjęcie"
    override val profileFocusEditTitle = "Zainteresowania i aktywności"
    override val profileFocusEditDescription = "Wybierz swoje sporty i styl życia, aby ukształtować swoją tożsamość."
    override val profileFocusEditSelectedLabel = "wybrano"
    override val profileFocusEditClearAll = "Wyczyść wszystko"
    override val profileFocusEditSearchPlaceholder = "Szukaj atrybutów…"
    override val profileFocusEditSportLabel = "Sport"
    override val profileFocusEditActivityLabel = "Aktywność"
    override val profileFocusEditLifestyleLabel = "Styl życia"
    override val profileFocusEditNoMatches = "Brak dopasowań"
    override val profileFocusEditPreferenceDetails = "Szczegóły preferencji"
    override val profileFocusEditPreferenceHint = "Opcjonalne, ale pomaga szybciej znaleźć podobnie myślące osoby."
    override val profileFocusEditNoteLabel = "Notatka"
    override val profileFocusEditNotePlaceholder = "Czego szukasz?"
    override val profileFocusEditAddDetails = "Dodaj szczegóły"
    override val profilePersonalEditTitle = "Dane osobowe"
    override val profilePersonalEditDescription = "Opowiedz o sobie, aby zacząć."
    override val profilePersonalEditFirstNameLabel = "Imię"
    override val profilePersonalEditLastNameLabel = "Nazwisko"
    override val profilePersonalEditAboutMeLabel = "O mnie"
    override val profilePersonalEditBioPlaceholder = "Opowiedz innym graczom coś o sobie…"
    override val profilePersonalEditDobLabel = "Data urodzenia"
    override val profilePersonalEditDobInvalid = "Wpisz poprawną datę"
    override val profilePersonalEditDobFuture = "Data urodzenia nie może być z przyszłości"
    override val profilePersonalEditCityLabel = "Miasto"
    override val profilePersonalEditCitySearchPlaceholder = "Szukaj miasta…"
    override val profilePersonalEditLanguagesLabel = "Języki"
    override val profilePersonalEditTypeLanguagePlaceholder = "Wpisz język…"
    override val profilePersonalEditAddLanguagePlaceholder = "Dodaj język"
    override val profileEditSheetPublicInfo = "Informacje publiczne"
    override val profileEditShellPublicInfo = "Informacje publiczne"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Dodaj wszystkie zdjęcia ($count)"
    override val profileCreatePostUploadFailed = "Przesyłanie nie powiodło się"
    override val profileCreatePostCreateFailed = "Nie udało się utworzyć posta"
    override val profileCreatePostTitle = "Utwórz post"
    override val profileCreatePostChooseLayout = "Wybierz układ"
    override val profileCreatePostFileTooLarge = "Plik jest za duży (maks. 50 MB)"
    override val profileCreatePostCreating = "Tworzenie..."
    override val profileCreatePostAddPhoto = "Dodaj zdjęcie"
    override val profileCreatePostContentLabel = "Treść posta"
    override val profileCreatePostContentPlaceholder = "Napisz coś o tym poście..."
    override val profileCreatePostCityLabel = "Miasto"
    override val profileCreatePostCityPlaceholder = "Wpisz nazwę miasta..."
    override val profileCreateStoryPickPhotoFirst = "Najpierw wybierz zdjęcie"
    override val profileCreateStoryUploadFailed = "Przesyłanie nie powiodło się"
    override val profileCreateStoryCreateFailed = "Nie udało się utworzyć relacji"
    override val profileCreateStoryTitle = "Utwórz relację"
    override val profileCreateStorySubtitle = "Twórz i udostępniaj swoje momenty"
    override val profileCreateStoryFileTooLarge = "Plik jest za duży (maks. 30 MB)"
    override val profileCreateStoryCreating = "Tworzenie..."
    override val profileCreateStoryDropHere = "Upuść tutaj swoje treści"
    override val profileCreateStoryMaxSize = " maks. 30 MB"
    override val profileFollowListFollowers = "Obserwujący"
    override val profileFollowListFollowing = "Obserwowani"
    override val profileFollowListNoResults = "Brak wyników"
    override val profileFollowListUnfollow = "Przestań obserwować"
    override val profileFollowListFollow = "Obserwuj"
    override val profileFollowListRemoved = "Usunięto"
    override val profileFollowListRemove = "Usuń"
    override val profileFollowListNotFollowingTitle = "Nie obserwujesz jeszcze nikogo"
    override val profileFollowListNotFollowingBody = "Obserwuj graczy, aby widzieć w swoim feedzie ich najnowsze posty, najlepsze akcje i relacje."
    override val profileFollowListDiscoverPlayers = "Odkrywaj graczy"
    override val profileFollowListNoFollowersTitle = "Na razie brak obserwujących"
    override val profileFollowListNoFollowersBody = "Udostępniaj posty i relacje z meczów, aby społeczność Cię zauważyła."
    override val profileDialogPreferenceDetails = "Szczegóły preferencji"
    override val profileStoryViewersTitle = "Kto widział tę relację?"
    override val profileStoryViewersNoViews = "Na razie brak wyświetleń"
    override val profileContentMobileOverview = "Przegląd"
    override val profileContentMobileFollowing = "Obserwowani"
    override val profileContentMobileFollowers = "Obserwujący"
    override val profileContentMobileAwardsComingSoon = "Nagrody już wkrótce"
    override val profileContentMobileRecentEvents = "Ostatnie wydarzenia"
    override val profileContentMobileNoEvents = "Na razie brak zaplanowanych wydarzeń"
    override val profileContentMobileNoEventsBody = "Wybierz nadchodzące wydarzenie i dołącz do gry!"
    override val profileContentMobileResultWin = "Wygrana"
    override val profileContentMobileResultDraw = "Remis"
    override val profileContentMobileResultLoss = "Porażka"
    override val profileContentMobileSportFallback = "Sport"
    override fun profileContentMobileFormat(format: Int) = "Format $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count członków"
    override val profileContentMobilePlayerHub = "Player Hub"
    override val profileContentMobileNoPostsTitle = "Na razie brak postów"
    override val profileContentMobileNoPostsOwnBody = "Udostępniaj zdjęcia z meczów i najlepsze akcje, aby wypełnić swój profil."
    override val profileContentMobileNoPostsOtherBody = "Ten gracz jeszcze niczego nie opublikował."
    override val profileContentMobileCardsUnavailable = "Karty niedostępne"
    override val profileContentMobileCardsLoadFailed = "Nie udało się wczytać kart"
    override val profileContentMobileNoCardsAvailable = "Brak dostępnych kart"
    override val profileContentMobileActiveBought = "Aktywne i kupione"
    override fun profileContentMobileOwnedCount(count: Int) = "Posiadane: $count"
    override val profileContentMobileAvailableForPurchase = "Dostępne do kupienia"
    override val profileContentMobileNewDesigns = "Regularnie nowe wzory"
    override val profileContentMobileNoCardsYet = "Na razie brak kart"
    override val profileContentMobileCardsTitle = "Karty"
    override val profileContentMobileAddPost = "Dodaj post"
    override val profileContentMobileUserFallback = "użytkownik"
    override val profileUserSheetError = "Coś poszło nie tak"
    override val profileUserSheetThisUser = "ten użytkownik"
    override fun profileUserSheetUnfollowTitle(name: String) = "Przestać obserwować $name?"
    override val profileUserSheetRefollowHint = "Możesz zacząć obserwować ponownie w każdej chwili."
    override val profileUserSheetUnfollow = "Przestań obserwować"

    // header
    override val headerNavHome = "Strona główna"
    override val headerNavAbout = "O nas"
    override val headerNavServices = "Usługi"
    override val headerNavProjects = "Projekty"
    override val headerNavContacts = "Kontakt"
    override val headerSportLabel = "Sport:"
    override val headerUserFallbackName = "Użytkownik"
    override val headerNoActiveEvents = "Brak aktywnych wydarzeń i rezerwacji"
    override val headerNoNotifications = "Brak powiadomień"
    override val headerYourActiveEvents = "Twoje aktywne wydarzenia "
    override val headerNotificationsTitle = "Powiadomienia "
    override val headerMarkAllRead = "Oznacz wszystkie jako przeczytane"
    override val headerLoadMore = "Wczytaj więcej"
    override val headerPendingApproval = "Oczekuje na zatwierdzenie"
    override val headerEventStatusNew = "Nowe"
    override val headerEventStatusInProgress = "W trakcie"
    override val headerEventStatusCompleted = "Zakończone"
    override val headerEventStatusCancelled = "Odwołane"
    override val headerBookingFallback = "Rezerwacja"
    override val headerActionView = "Zobacz"
    override val headerActionReply = "Odpowiedz"
    override val headerActionUnfollow = "Przestań obserwować"
    override val headerActionFollowBack = "Obserwuj też"
    override val headerActionAccept = "Akceptuj"
    override val headerActionDecline = "Odrzuć"
    override val headerConfirmTitle = "Na pewno?"
    override val headerSignOutConfirmMessage = "Zostaniesz wylogowany z Areny na tym urządzeniu. Twoje dane pozostaną bezpieczne."
    override val headerSignOutConfirmLabel = "Wyloguj się"
    override val headerDeleteConfirmMessage = "Usunięcie profilu jest nieodwracalne. Wszystkie kredyty, momenty i statystyki zostaną skasowane."
    override val headerDeleteConfirmLabel = "Potwierdź usunięcie"
    override val headerDeleteProfileFailed = "Nie udało się usunąć profilu. Spróbuj ponownie."
    override val headerUploading = "Przesyłanie..."
    override val headerVisualStyle = "Styl wizualny"
    override val headerLightTheme = "Jasny motyw"
    override val headerSyncWithSportType = "Synchronizuj ze sportem"
    override val headerManageSubscription = "Zarządzaj subskrypcją"
    override val headerCurrentPlan = "Obecny plan:"
    override val headerPlanFree = "Darmowy"
    override val headerPlanUpgrade = "Ulepsz"
    override val headerSignOut = "Wyloguj się"
    override val headerSigningOut = "Wylogowywanie..."
    override val headerDeleteProfile = "Usuń profil"
    override val headerRequestNoLongerAvailable = "Ta prośba nie jest już dostępna."
    override val headerRequestProcessFailed = "Nie udało się przetworzyć prośby. Spróbuj ponownie."
    override val headerSelectClub = "Wybierz klub"
    override val headerAddClub = "Dodaj klub"
    override val headerSwitchToPlayer = "Przełącz na gracza"
    override val headerLogout = "Wyloguj"
    override val headerLoggingOut = "Wylogowywanie..."
    override val headerSigningIn = "Logowanie..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "łączy"
    override val homeHeroAthletes = "sportowców"
    override val homeHeroAndTeams = "i drużyny"
    override val homeHeroWorldwideFor = "na całym świecie dla"
    override val homeSectionCreateEventsTitle = "Twórz wydarzenia"
    override val homeSectionCreateEventsHighlight = "wydarzenia"
    override val homeSectionCreateEventsSubtitle1 = "Wybierz sport, ustal harmonogram"
    override val homeSectionCreateEventsSubtitle2 = "i dodaj miejsce gry."
    override val homeSectionClubsTitle = "Odkrywaj najlepsze kluby"
    override val homeSectionClubsHighlight = "kluby"
    override val homeSectionTeammatesTitle = "Znajdź idealnych partnerów do gry"
    override val homeSectionTeammatesHighlight = "partnerów"
    override val homeSectionMomentsTitle = "Dziel się chwilami, łącz się ze znajomymi"
    override val homeSectionMomentsHighlight = "znajomymi"
    override val homeSectionStatsTitle = "Śledź statystyki, obserwuj postępy i personalizuj kartę"
    override val homeSectionStatsHighlight = "postępy"
    override val homeAltEventsScreen = "Ekran wydarzeń"
    override val homeAltCreateEventScreen = "Ekran tworzenia wydarzenia"
    override val homeAltCreateEventModal = "Okno tworzenia wydarzenia"
    override val homeAltEventDetailScreen = "Ekran szczegółów wydarzenia"
    override val homeAltClubsScreen = "Ekran klubów"
    override val homeAltClubGallery = "Galeria klubu"
    override val homeAltClubDetail = "Szczegóły klubu"
    override val homeAltClubAmenities = "Udogodnienia klubu"
    override val homeAltClubMap = "Mapa lokalizacji klubu"
    override val homeAltDiscoverPeople = "Odkrywaj osoby"
    override val homeAltPlayerDiscoveryCard = "Karta odkrywania graczy"
    override val homeAltMatchedInterests = "Wspólne zainteresowania"
    override val homeAltMatchedInterestsModal = "Okno wspólnych zainteresowań"
    override val homeAltItsAMatch = "To match"
    override val homeAltFeedScreen = "Ekran feedu"
    override val homeAltFeedPost = "Post w feedzie"
    override val homeAltGameMomentsPost = "Post z momentami z gry"
    override val homeAltChatScreen = "Ekran czatu"
    override val homeAltProfileOverview = "Przegląd profilu"
    override val homeAltProfileDashboard = "Panel profilu"
    override val homeAltPlayerStatsRadar = "Radar statystyk gracza"
    override val homeAltPlayerStatsCard = "Karta statystyk gracza"
    override val homeAltRatePerformance = "Oceń występ"
    override val homeAltRatePerformanceModal = "Okno oceny występu"
    override val homeItsYourMatch = "To Twój match!"
    override val homeLabelClubDetails = "Szczegóły klubu"
    override val homeLabelGameMoments = "Momenty z gry"
    override val homeLabelPlayerStats = "Statystyki gracza"
    override val homeLabelRatePerformance = "Oceń występ"
    override val homeFooterTagline = "Twoja globalna społeczność sportowa"
    override val homeFooterBlurb = "Znajdź osoby w okolicy do gry w piłkę nożną, tenisa, koszykówkę, padla lub siatkówkę — dołączaj do luźnych meczów i lokalnych wydarzeń sportowych albo twórz własne na Arenie."
    override val homeFooterAbout = "O nas"
    override val homeFooterTerms = "Warunki korzystania"
    override val homeFooterPrivacy = "Polityka prywatności"
    override val homeFooterPricing = "Cennik"
    override val homeFooterRefund = "Polityka zwrotów"
    override val homeFooterSupports = "Pomoc"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "POBIERZ W"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "POBIERZ Z"
    override val homeStoreGoogleName = "Google Play"
    override fun homeStoreGoogleComingSoon(days: Int) =
        "Aplikacja będzie dostępna w Google Play za $days ${if (days == 1) "dzień" else "dni"}"

    override val homeStoryHeroTitle = "Znajdź ludzi do **wspólnego sportu**"
    override val homeStoryHeroSub = "Prawdziwe gry w okolicy · Dołącz w dwa tapnięcia"
    override val homeStoryJoinFree = "Dołącz za darmo"
    override val homeStoryEventsTitle = "Dołącz do gier **w okolicy**"
    override val homeStoryEventsSub = "Piłka nożna, koszykówka, tenis, siatkówka, padel i więcej"
    override val homeStoryMatchTitle = "Matchuj się z **graczami**"
    override val homeStoryMatchSub = "Znajdź partnerów na swoim poziomie"
    override val homeStoryClubsTitle = "Rezerwuj prawdziwe **korty**"
    override val homeStoryClubsSub = "Ponad 1200 zweryfikowanych klubów w całej Europie"
    override val homeStoryMomentsTitle = "Dziel się **grą**"
    override val homeStoryMomentsSub = "Publikuj momenty, czatuj i bądź w kontakcie"
    override val homeStoryStatsTitle = "Zbuduj kartę **gracza**"
    override val homeStoryStatsSub = "Statystyki, oceny i karta, która rośnie z tobą"
    override val homeStoryReadyTitle = "Gotowy, by **grać**?"
    override val homeStoryReadySub = "Za darmo · iOS i Android"

    // dashboard
    override val dashboardTabAnalytics = "Analityka"
    override val dashboardTabSchedule = "Harmonogram"
    override val dashboardRatingTitle = "Rating"
    override val dashboardReviews = "opinii"
    override val dashboardAvgDuration = "Śr. czas trwania"
    override val dashboardTotalRevenue = "Łączny przychód"
    override val dashboardTotalBookings = "Łączna liczba rezerwacji"
    override val dashboardArenaSchedule = "Harmonogram Areny"
    override val dashboardThisWeek = "W tym tygodniu"
    override val dashboardAddEvent = "Dodaj wydarzenie"
    override val dashboardTimeHeader = "Godzina"
    override val dashboardCustomerFallback = "Klient"
    override val dashboardRevenueTitle = "Przychód"
    override val dashboardBookingsTitle = "Rezerwacje"
    override val dashboardBookingStatusTitle = "Status rezerwacji"
    override val dashboardBookingHeatmapTitle = "Mapa cieplna rezerwacji"
    override val dashboardDonutTotal = "Łącznie"
    override val dashboardBookingsTooltipPrefix = "Rezerwacje "
    override val dashboardStatusConfirmed = "Potwierdzone"
    override val dashboardStatusCompleted = "Zakończone"
    override val dashboardStatusPending = "Oczekujące"
    override val dashboardStatusUnpaid = "Nieopłacone"
    override val dashboardStatusDeclined = "Odrzucone"
    override val dashboardNoData = "Brak danych"
    override val dashboardDayMon = "Pon"
    override val dashboardDayTue = "Wt"
    override val dashboardDayWed = "Śr"
    override val dashboardDayThu = "Czw"
    override val dashboardDayFri = "Pt"
    override val dashboardDaySat = "Sob"
    override val dashboardDaySun = "Nd"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count rezerwacji"

    // arena
    override val arenaActionViewResults = "Zobacz wyniki"
    override val arenaActionWatchLive = "Oglądaj na żywo"
    override val arenaActionJoinNow = "Dołącz teraz"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Nowe"
    override val arenaStatusCompleted = "Zakończone"
    override val arenaStatusCanceled = "Odwołane"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total uczestników"
    override fun arenaMembersCount(count: Int) = "$count uczestników"
    override fun clubDistanceKm(km: String) = "$km km"
    override fun clubKmAway(km: String) = "$km km stąd"
    override val pageAmenities = "Udogodnienia"
    override val clubOpenLabel = "Otwarte"
    override val clubClosed = "Zamknięte"
    override fun clubUntilTime(time: String) = "do $time"
    override fun clubOpensAt(time: String) = "Otwarcie o $time"
    override val clubTabPhotos = "Zdjęcia"
    override val clubNoPhotos = "Brak zdjęć"
    override val clubNoAmenities = "Brak udogodnień"
    override val clubMapComingSoon = "Mapa wkrótce"
    override fun arenaTeamsCount(count: Int) = "$count drużyn"
    override fun arenaFormat(format: String) = "Format $format"
    override fun arenaFinalScore(score: String) = "Wynik końcowy $score"
    override fun arenaDuration(duration: String) = "Czas trwania $duration"
    override val arenaLoadingClubs = "Wczytywanie klubów..."
    override val arenaLoadingMoreEvents = "Wczytywanie kolejnych wydarzeń..."
    override val arenaLoadingMoreClubs = "Wczytywanie kolejnych klubów..."
    override val arenaLocationLabel = "Lokalizacja: "
    override val arenaAllCities = "Wszystkie miasta"
    override val arenaCommunityAll = "Wszystkie"
    override val arenaCommunityUnnamed = "Bez nazwy"
    override val arenaTabClubs = "Kluby"
    override val arenaTabEvents = "Wydarzenia"
    override val arenaEmptyTitle = "Na razie brak zaplanowanych wydarzeń"
    override val arenaEmptySubtitle = "Utwórz wydarzenie, aby mieć czat meczowy i śledzenie na żywo."
    override val arenaAddEvent = "Dodaj wydarzenie"
    override val arenaNoClubsTitle = "Na razie brak klubów"
    override val arenaNoClubsSubtitle = "Kluby pojawią się tutaj"

    // people
    override val peopleErrorLoad = "Nie udało się wczytać osób"
    override val peopleCaughtUpTitle = "To już wszyscy"
    override val peopleCaughtUpSubtitle = "Wróć później po kolejnych graczy."
    override val peopleRefresh = "Odśwież"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Twój feed jest pusty"
    override val feedEmptySubtitle = "Obserwuj graczy, aby widzieć tutaj ich posty i relacje."
    override val feedNoCommentsTitle = "Na razie brak komentarzy"
    override val feedNoCommentsSubtitle = "Skomentuj jako pierwszy."
    override val feedMessagePlaceholder = "Napisz wiadomość..."
    override val feedLikeZero = "Polub"
    override val feedLikeOne = "1 polubienie"
    override fun feedLikeMany(count: Int) = "$count polubień"

    // auth
    override val authWelcomeTitle = "Witaj w Arenie!"
    override val authWelcomeSubtitle = "Zaloguj się przez Google lub Apple, aby utworzyć profil, odblokować tę stronę i rozpocząć z nami swoją sportową przygodę."
    override val authAgreePrefix = "Kontynuując, akceptujesz nasze"
    override val authTerms = "Warunki"
    override val authPrivacy = "Prywatność"

    // layout
    override val layoutComingSoon = "Już wkrótce"
}
